// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"c810124823d576fd0c33","811":"f1bb9ec2f93a0e91a00e"}[chunkId] + ".js";
};